import QuickSearch from './QuickSearch';

export { QuickSearch };
export default QuickSearch;
